import { useEffect } from "react";
import "@mantine/core/styles.css";
import "antd/dist/reset.css";
import "./assets/styles/main.css";
import "./assets/styles/responsive.css";
import { ConfigProvider } from "antd";
import theme from "./assets/styles/theme";
import Router from "./router";
import { useDispatch } from "react-redux";
import { authActions } from "./store/slices/auth-slice";
import { authGetCurrentUser } from "./store/actions/auth-actions";

function App() {
  const dispatch = useDispatch();

  // const notificationOpen = useSelector((state) => state.app.notificationOpen);
  // const notificationSeverity = useSelector(
  //   (state) => state.app.notificationSeverity
  // );
  // const notificationMessage = useSelector(
  //   (state) => state.app.notificationMessage
  // );

  // const handleCloseNotification = () => {
  //   dispatch(resetAppNotification());
  // };

  useEffect(() => {
    const storedUserSession = localStorage.getItem("usersession");
    const storedUserInfo = localStorage.getItem("userinfo");

    if (storedUserSession && storedUserInfo) {
      const userLoginData = JSON.parse(storedUserSession);
      const userInfoData = JSON.parse(storedUserInfo);

      dispatch(authActions.login({ userLoginData, userInfoData }));
      dispatch(authGetCurrentUser(userLoginData));
    }
  }, [dispatch]);

  return (
    <ConfigProvider theme={theme}>
      <div className="App relative flex">
        <Router />
      </div>
    </ConfigProvider>
  );
}

export default App;
